if (document.querySelector('.js-openVideo')) {

  const stopVideo = (block) => {
    if (block.querySelector('video')) {
      block.querySelector('video').pause();
      block.querySelector('video').currentTime = 0;
    } else if (block.querySelector('iframe')) {
      const srcVideo = block.querySelector('iframe').getAttribute('src')
      block.querySelector('iframe').setAttribute('src', srcVideo);
    }
  }

  document.querySelectorAll('.js-openVideo').forEach(elem => {
    elem.addEventListener('click', event => {
      const eventTar = event.target;

      eventTar.closest('.video-item').querySelector('.js-modalVideo').classList.add('is-open')
    })
  })

  document.querySelectorAll('.js-closeModal').forEach(elem => {
    elem.addEventListener('click', event => {
      const eventTar = event.target;

      eventTar.closest('.js-modalVideo').classList.remove('is-open')
      stopVideo(eventTar.closest('.js-modalVideo'));
    })
  })
  document.querySelectorAll('.card-video-modal__overlay').forEach(elem => {
    elem.addEventListener('click', event => {
      const eventTar = event.target;
      if (eventTar.classList.contains('card-video-modal__overlay')) {
        eventTar.closest('.js-modalVideo').classList.remove('is-open')
        stopVideo(eventTar.closest('.js-modalVideo'));
      }
    })
  })
}